import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../baseQueries/axiosBaseQuery";
import baseUrls from "../service";

/**
 * Valid Query response type. when there is no http error
 *  @prop data   -- response data from request.
 *  @prop errors  --  server side error.
 *  @prop message  -- response message from request.
 *  @prop state   -- request response state.
 *  @prop type  -- request response type(enum)
 */
export interface queryResponse<TReturnType> {
    data?: TReturnType;
    errors?: any;
    message?: string;
    state?: boolean;
    type?: number;
}

/**
 * Coutry Api
 * Using Redux toolkit CreateApi Method  to define country endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaBackendApi = createApi({
    reducerPath: "sibaApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.backend}` }),
    endpoints: (builder) => ({})
});

/**
 * Auth Api
 * Using Redux toolkit CreateApi Method  to define auth endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaAuthApi = createApi({
    reducerPath: "sibaAuthApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.authBackend}` }),
    endpoints: (builder) => ({})
});

/**
 * Communications Api
 * Using Redux toolkit CreateApi Method  to define KPI endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaCommunicationApi = createApi({
    reducerPath: "sibaCommunicationApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.communication}` }),
    endpoints: (builder) => ({})
});

/**
 * Insurance Global Setups Api
 * Using Redux toolkit CreateApi Method  to define KPI endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibagenGlobalSetupApi = createApi({
    reducerPath: "sibagenGlobalSetupApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.globalSetups}` }),
    endpoints: (builder) => ({})
});

/**
 * Account Transaction Api
 * Using Redux toolkit CreateApi Method  to define KPI endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaExceptionLogApi = createApi({
    reducerPath: "sibaExceptionLogApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.exceptionLog}` }),
    endpoints: (builder) => ({})
});

/**
 * Account Transaction Api
 * Using Redux toolkit CreateApi Method  to define KPI endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaDocumentApi = createApi({
    reducerPath: "sibaDocumentApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.document}` }),
    endpoints: (builder) => ({})
});

/**
 * Account Transaction Api
 * Using Redux toolkit CreateApi Method  to define KPI endpoints
 * and describe how to retrieve data from endpoints,
 *  @prop reducer path. define reducer.
 * @prop baseQuery  -- basequery configuration for country api defined in axoisBaseQuery
 * @pop enpoints  -- country endpoints defined.
 */
export const sibaReportApi = createApi({
    reducerPath: "sibaReportApis",
    baseQuery: axiosBaseQuery({ baseUrl: `${baseUrls.issueReport}` }),
    endpoints: (builder) => ({})
});
